import React from "react";

export default function EmptyState({message}) {
  return(
    <div className="emptyState _paddingTop--xxxxlarge">
      <i className="materialIcon --large">move_to_inbox</i>
      <p className="byline">{message}</p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/projectFinder/components/EmptyState.js